import * as Yup from 'yup';

const validatePostcode = Yup.string()
  .uppercase()
  .matches(
    /\b(GIR ?0AA|SAN ?TA1|(?:[A-PR-UWYZ](?:\d{0,2}|[A-HK-Y]\d|[A-HK-Y]\d\d|\d[A-HJKSTUW]|[A-HK-Y]\d[ABEHMNPRV-Y])) ?\d[ABD-HJLNP-UW-Z]{2})\b/,
    'Postcode is not valid'
  )
  .required('Postcode cannot be empty');

const validateNationalInsuranceNumber = Yup.string().matches(
  /^\s*[a-zA-Z]{2}(?:\s*\d\s*){6}[a-zA-Z]?\s*$/g,
  'National insurance number is not valid'
);

export { validatePostcode, validateNationalInsuranceNumber };
